import React from 'react';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useMutation } from 'react-fetching-library';
import { useDispatch } from 'react-redux';
import { Box, TextField, Button, Modal, Card, CardContent, CardHeader, Typography, Alert, LinearProgress, IconButton, Tooltip, Stack } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import Iconify from '../../../components-core/Iconify';

import OrdersModal from './OrdersModal';
import SendMessageResultModal from './SendMessageResultModal';
import { sendNotificationsAction } from '../../../services/request';
import { setAllowAutoOrderUpdate } from '../../../services/redux-actions';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};

const validationSchema = Yup.object({
  message: Yup.string().required('To pole nie może być puste'),
  subject: Yup.string().required('To pole nie może być puste')
});

export default function SendMessage({ idList, setIdList, ordersDataForMessages }) {
  const dispatch = useDispatch();
  const { mutate, error, loading, reset } = useMutation(sendNotificationsAction);
  const [open, setOpen] = React.useState(false);
  const [openOrdersModal, setOpenOrdersModal] = React.useState(false);
  const [openResultModal, setOpenResultModal] = React.useState(false);
  const [result, setResult] = React.useState({});

  const handleOpen = () => {
    dispatch(setAllowAutoOrderUpdate(false));
    setOpen(true);
  };

  const handleClose = () => {
    reset();
    setOpen(false);
    setIdList(ordersDataForMessages.map(order => order.id));
    dispatch(setAllowAutoOrderUpdate(true));
  };

  const handleOpenOrdersModal = () => setOpenOrdersModal(true);
  const handleCloseOrdersModal = () => setOpenOrdersModal(false);

  const handleOpenResultModal = () => setOpenResultModal(true);
  const handleCloseResultModal = () => setOpenResultModal(false);

  const handleSubmit = async values => {
    const { error: mutateError, payload } = await mutate(values);
    if (!mutateError) {
      setResult(payload);
      handleOpenResultModal();
      formik.resetForm();
    }
  };

  const formik = useFormik({
    initialValues: {
      message: '',
      subject: ''
    },
    validationSchema,
    validateOnChange: false,
    onSubmit: values => {
      values.orders_id = idList;
      handleSubmit(values);
    }
  });

  return (
    <>
      <Box sx={{ p: 3, width: '100%', display: 'flex', flexDirection: 'row' }}>
        <Button variant="contained" fullWidth endIcon={<EmailIcon />} onClick={handleOpen}>Wyślij</Button>
      </Box>
      <Modal
        open={open}
        onClose={handleClose}
      >
        <Card sx={{ ...style, width: '35vw' }}>
          <CardHeader
            title="Wyślij wiadomość"
            action={
              <Tooltip title="lista zamówień">
                <IconButton color="primary" onClick={handleOpenOrdersModal}>
                  <Iconify icon="icon-park-outline:transaction-order" />
                </IconButton>
              </Tooltip>
            }
            sx={{ textAlign: 'center' }}
          />
          <CardContent>
            <form onSubmit={formik.handleSubmit} style={{ display: 'flex', flexDirection: 'column' }}>
              <Tooltip placement="top-start" title={ordersDataForMessages.map(order => idList.includes(order.id) ? `${order.email}, ` : '')}>
                <Stack direction="row" spacing={1}>
                  <Typography variant="subtitle2">do:</Typography>
                  <Typography noWrap variant="body2">{ordersDataForMessages.map(order => idList.includes(order.id) ? `${order.email}, ` : '')}</Typography>
                </Stack>
              </Tooltip>
              <Box height={20}/>
              <TextField
                id="subject"
                name="subject"
                label="Temat"
                value={formik.values.subject}
                onChange={formik.handleChange}
                error={formik.errors.subject && formik.touched.subject}
                helperText={formik.errors.subject}
              />
              <Box height={20}/>
              <TextField
                id="message"
                name="message"
                multiline
                rows={8}
                label="Treść wiadomości"
                value={formik.values.message}
                onChange={formik.handleChange}
                error={formik.errors.message && formik.touched.message}
                helperText={formik.errors.message}
              />
              { error
                ? <>
                  <Box height={40}/>
                  <Alert variant="outlined" severity="error">Nie udało się wysłać wiadomości</Alert>
                </>
                : null}
              <Box height={40}/>
              { loading
                ? <>
                  <LinearProgress color="primary" />
                </>
                : <Button type="submit" variant="contained">
                  Wyślij
                </Button>}
            </form>
          </CardContent>
        </Card>
      </Modal>
      <OrdersModal
        open={openOrdersModal}
        handleClose={handleCloseOrdersModal}
        idList={idList}
        setIdList={setIdList}
        ordersDataForMessages={ordersDataForMessages}
      />
      <SendMessageResultModal open={openResultModal} handleClose={handleCloseResultModal} result={result} />
    </>
  );
}
